import React, { Component } from 'react';
import styled from 'styled-components';

import Input from '../../components/Input';
import ChipInput from '../../components/ChipInput';
import JsonLogicBuilder from '../../components/JsonLogicBuilder';
import Notification from '../../components/Notification';

import {getLogicBuilderVariables} from './shared';
import DeletableCard from './DeletableCard';
import SubConfiguration from './SubConfiguration';
import { areShallowEqual } from '../../lib/helpers';
import { Checkbox } from './QuestionBuilder';

class AlertBuilder extends Component {
  shouldComponentUpdate(prevProps, prevState) {
    const {alert, validations} = this.props;

    if (prevState !== this.state) {
      // Always update when the local state changes.
      return true;
    }

    if (prevProps.alert !== alert) {
      // Always update when the alert changes.
      return true;
    }

    if (!areShallowEqual(prevProps.validations, validations)) {
      // Always update when the validations have changed.
      return true;
    }

    return false;
  }

  setAlertState = reducer => {
    const {alert, onChange} = this.props;

    onChange({
      ...alert,
      ...(typeof reducer === 'function' ? reducer(alert) : reducer)
    });
  }

  handleDeleteAlert = () => {
    const {alert, onRemove} = this.props;
    onRemove(alert);
  }

  handleAlertNameChanged = e => {
    const {alert} = this.props;

    if (alert.name !== e.target.value) {
      this.setAlertState({name: e.target.value});
    }
  }

  handleContactsChanged = alertContacts => {
    this.setAlertState({alertContacts});
  }

  handleExpressionChanged = expression => {
    this.setAlertState({expression: JSON.stringify(expression)});
  }

  setIsMobileAlertChecked() {
    const { alert } = this.props;
    this.setAlertState({mobileAlert: !alert.mobileAlert});
  }

  render() {
    const {form, catalog, users, alert, validations} = this.props;

    return (
      <DeletableCard
        focusable
        dialogTitle="Delete this alert?"
        dialogDescription="Are you sure you want to delete this alert? This cannot be undone."
        ok="Delete"
        onOk={this.handleDeleteAlert}>
        <AlertForm>
          <Input
            id={`alert_title_${alert.id}`}
            label="Alert name"
            placeholder="Enter a short name for this alert"
            defaultValue={alert.name}
            onBlur={this.handleAlertNameChanged}
            invalid={validations.name}
            validationText={validations.name}
          />
          <ChipInput
            id={`alert_contacts_${alert.id}`}
            label="Alert contacts"
            placeholder="Choose who to notify when this alert is triggered"
            value={alert.alertContacts}
            suggestions={users}
            onChange={this.handleContactsChanged}
          />
          {validations.expression && (
            <Notification mini error>{validations.expression}</Notification>
          )}
          <Condition>
            <label>Trigger this alert when...</label>
            <SubConfiguration>
              <SubConfiguration.Item>
                <JsonLogicBuilder
                  expand
                  variables={getLogicBuilderVariables(form, catalog)}
                  value={JSON.parse(alert.expression)}
                  onChange={this.handleExpressionChanged}
                />
              </SubConfiguration.Item>
            </SubConfiguration>
          </Condition>
            <Checkbox> 
              <input
                disabled={false}
                type="checkbox"
                checked={alert.mobileAlert}
                onChange={e => this.setIsMobileAlertChecked()}
              />
              &nbsp;
              Notify Mobile User
            </Checkbox>
        </AlertForm>
      </DeletableCard>
    );
  }
}

const AlertForm = styled.div`
  > * {
    margin-bottom: 1.5rem;

    :last-child {
      margin-bottom: 0;
    }
  }
`;

const Condition = styled.div`
  label {
    display: block;
    margin-bottom: 0.5rem;
  }
`;

export default AlertBuilder;
